import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import {
  Box as DarkBox,
  Button as DarkButton,
  Flex as DarkFlex,
  tokenPrefix,
} from '@hivewatch/dark'

interface DeviceTraceLogsEmptyStatePropsI {
  /** Omitted when the incident has no Facility to fall back to. */
  onViewFacility?: () => void
}

/**
 * Device tab content when the device has no trace log events (ENG-33914).
 * Cameras and other non-ACS devices often have none, so point the operator
 * at the Facility tab instead of leaving a blank panel.
 */
export const DeviceTraceLogsEmptyState = ({
  onViewFacility,
}: DeviceTraceLogsEmptyStatePropsI) => {
  const { t } = useTranslation()
  const mode = useLightMode()
  const prefix = tokenPrefix(mode)

  return (
    <DarkFlex
      alignItems='center'
      data-testid='traceLog_deviceEmptyState'
      direction='column'
      gap='12px'
      py='32px'
      textAlign='center'
    >
      <DarkBox
        color={`${prefix}text.primary`}
        fontSize='14px'
        fontWeight='500'
        lineHeight='20px'
      >
        {t('incidents:drawer_trace_log_device_empty_title')}
      </DarkBox>
      <DarkBox
        color={`${prefix}text.secondary`}
        fontSize='14px'
        lineHeight='20px'
      >
        {t('incidents:drawer_trace_log_device_empty_description')}
      </DarkBox>
      {onViewFacility && (
        <DarkButton
          colorScheme={mode}
          onClick={onViewFacility}
          size='sm'
          variant='secondary'
        >
          {t('incidents:drawer_trace_log_view_facility')}
        </DarkButton>
      )}
    </DarkFlex>
  )
}
